module.exports = __webpack_public_path__ + "static/kiper-jim-6d392e68481e51d5ff6dd478b097584e.jpg";